import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config/config';
import { useAdmin } from '../context/AdminContext';
import { useAuthSession, clearAuthStorage } from '../context/AuthSessionContext';
import '../css/MainPage.css';
import { getFilterParams } from '../utils/apiUtils';
import AuthLayout from '../components/AuthLayout';

const DoctorMainPage = () => {
    const [user_email, setUsername] = useState('');
    const [user_pw, setPassword] = useState('');
    const [error, setError] = useState('');

    const navigate = useNavigate();
    const { updateAdminInfo } = useAdmin();
    const { setSession } = useAuthSession();



    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');

        if (!user_email || !user_pw) {
            setError('이메일과 비밀번호를 모두 입력해주세요.');
            return;
        }

        try {
            const response = await axios.post(`${API_BASE_URL}/api/login`, {
                user_email: user_email,
                user_pw: user_pw
            }, {
                withCredentials: true
            });

            if (response.data.status === 'success') {
                const { token, user } = response.data;

                // 이전 로그인의 권한 값(is_super_admin, 그룹 id 등)이 남아 있으면 새 계정이
                // 그 권한으로 화면을 그린다. 로그아웃 없이 창을 닫은 경우가 그렇다(2026-09-15).
                clearAuthStorage();
                setSession({ token, user });

                // 주치의 정보 설정
                const adminInfo = {
                    hospitalId: user.hospital_id || '1',
                    hospitalName: user.hospital_name || '기본병원',
                    regionCode: user.region_code || '1',
                    regionName: user.region_name || '기본지역',
                    districtCode: user.district_code || '1',
                    districtName: user.district_name || '기본구역',
                    groupRole: user.role,
                    groupId: user.group_id
                };

                localStorage.setItem('hospital_id', adminInfo.hospitalId);
                localStorage.setItem('hospital_name', adminInfo.hospitalName);
                localStorage.setItem('region_code', adminInfo.regionCode);
                localStorage.setItem('region_name', adminInfo.regionName);
                localStorage.setItem('district_code', adminInfo.districtCode);
                localStorage.setItem('district_name', adminInfo.districtName);
                localStorage.setItem('group_role', adminInfo.groupRole);
                localStorage.setItem('group_id', adminInfo.groupId);

                // AdminContext 업데이트
                updateAdminInfo(adminInfo);

                // 필터 파라미터 가져오기
                await getFilterParams();

                // 로그인 성공 후 ControlCenter로 이동
                navigate('/ControlCenter');
            } else {
                setError(response.data.message || '로그인에 실패했습니다.');
            }
        } catch (error) {
            console.error('Login error:', error);
            if (error.response && error.response.data && error.response.data.message) {
                setError(error.response.data.message);
            } else {
                setError('로그인 중 오류가 발생했습니다.');
            }
        }
    };

    const navigateToSignup = () => {
        navigate('/Signup?type=doctor');
    };

    return (
        <AuthLayout
            eyebrow="주치의 · 기관 담당자"
            title="주치의 로그인"
            description="센터 계정의 메일 주소로 로그인하세요."
            footer={(
                <>
                    아직 계정이 없나요?{' '}
                    <button type="button" className="auth-page__textlink auth-page__textlink--primary" onClick={navigateToSignup}>회원가입</button>
                </>
            )}
        >
            <form onSubmit={handleLogin} className="auth-page__form" noValidate>
                <div className="sds-field">
                    <label className="sds-label" htmlFor="doctor-login-email">메일 주소</label>
                    <input
                        id="doctor-login-email"
                        className={`sds-input${error ? ' sds-input--error' : ''}`}
                        type="text"
                        placeholder="메일 주소를 입력하세요"
                        value={user_email}
                        onChange={(e) => setUsername(e.target.value)}
                        autoComplete="username"
                        aria-invalid={error ? 'true' : undefined}
                        aria-describedby={error ? 'doctor-login-error' : undefined}
                    />
                </div>
                <div className="sds-field">
                    <label className="sds-label" htmlFor="doctor-login-password">비밀번호</label>
                    <input
                        id="doctor-login-password"
                        className={`sds-input${error ? ' sds-input--error' : ''}`}
                        type="password"
                        placeholder="비밀번호를 입력하세요"
                        value={user_pw}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="current-password"
                        aria-invalid={error ? 'true' : undefined}
                        aria-describedby={error ? 'doctor-login-error' : undefined}
                    />
                    {error && <p className="sds-field-error" id="doctor-login-error" role="alert">{error}</p>}
                </div>
                <button type="submit" className="sds-btn sds-btn--primary">로그인</button>
            </form>
        </AuthLayout>
    );
};

export default DoctorMainPage;
